import { useMutation } from '@tanstack/react-query';
import { myPageService } from 'shared/src/api';

export const usePatchMyInfo = () => {
  return useMutation({
    mutationFn: myPageService.patchMyInfo,
    throwOnError: false,
  });
};
